import { useSelector } from 'react-redux';
import { states } from '@/constants/lifecycle';
import { isAuthenticated } from '@/auth/helper';

const useLogoutPage = () => {
  const { state, commonsMode } = useSelector(({ auth }) => auth);
  return { commonsMode, isAuthenticatedUser: isAuthenticated(state) };
};

const useLayoutPage = () => {
  const { currentUser } = useSelector(({ auth }) => auth);
  const { theme } = useSelector(({ themes }) => themes);
  return { readStatus: currentUser?.readStatus || states.PENDING, theme };
};

const usePageTracker = () => {
  const { title } = useSelector(({ layout }) => layout);
  return { title };
};

export default {
  useLayoutPage,
  useLogoutPage,
  usePageTracker,
};
